module.exports = __webpack_public_path__ + "static/assets/82931ac151931120d56dab33fd515e72.png";